<template>
    <div class="knd-chat-operator">
	<div class="chat knd-pb-5 knd-bg-red-dark">
		<div class="chat-header knd-bg-red-light knd-pt-5 knd-border-b-2 knd-border-green-light">
			<div class="knd-flex knd-wrapper__xl knd-m-auto">
				<div class="chat-header__tab knd-border-2 knd-border-green-light knd-px-2 knd-py-2 knd-mr-1">Mark55</div>
				<div class="chat-header__tab knd-border-2 knd-border-green-light knd-px-2 knd-py-2 knd-mr-1">Dick</div>
				<div class="chat-header__tab knd-border-2 knd-border-green-light knd-px-2 knd-py-2 knd-mr-1">Marcel</div>
				<div class="chat-header__tab knd-border-2 knd-border-green-light active knd-bg-green-light knd-px-2 knd-py-2 knd-mr-1">{{$store.state.user.name}}</div>
				<div class="chat-header__tab knd-border-2 knd-border-green-light knd-px-2 knd-py-2 knd-mr-1">Johny</div>
			</div>
		</div>

        <ChatContainer :content="content" />
	</div>

    </div>
</template>

<script>
    import ChatContainer from './chat-container.vue';

    export default {
		props: {
			content: {
				type: Object
			},
		},
        components: {
            ChatContainer
        },
		data: function() {
			return {
				items: this.content.chat_repeater
			}
		},
        methods: {},
    }
</script>

<style lang="scss">


.chat-header__tab {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
	border-bottom: none;
	pointer-events: none;
}

</style>